import { styled } from '@mui/material';
import type { ScrollOrientation } from 'ui/ScrollableList/types';

const StySidePanel = styled('div', {
    shouldForwardProp: (prop) => prop !== 'orientation',
})<{ orientation: ScrollOrientation }>(({ theme, orientation }) => ({
    background: theme.palette.lightGrey,
    borderRadius: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    ...(orientation === 'vertical' && { flex: 1, minHeight: 0 }),
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    width: '100%',
}));

export default StySidePanel;
